module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon7.43245612.svg";